module.exports = __webpack_public_path__ + "static/assets/711b88b97888739ed7e6dc2e1e4c164a.png";